import { LOADING, STATUS_CODE_SUCCESS } from "../../../constants/constant";
import {
  SUBMIT_LAUNCH_CARRIER,
  SUBMIT_LAUNCH_CARRIER_SUCCESS,
  SUBMIT_LAUNCH_CARRIER_FAILED,
  SUBMIT_LAUNCH_CARRIER_RESET,
} from "../../actions/ActionType";

const initialState = {
  status: "",
  isLoading: false,
};

export default function submitCarrierReducer(state = initialState, action) {
  switch (action.type) {
    case SUBMIT_LAUNCH_CARRIER: {
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;
    }

    case SUBMIT_LAUNCH_CARRIER_SUCCESS: {
      let userRes = Object.assign({}, state);
      userRes.status = action.data.status_message;
      userRes.isLoading = false;
      userRes.statusCode = action.data.status_code;
      if (userRes.statusCode !== STATUS_CODE_SUCCESS) {
        userRes.message = action.data.message;
        userRes.error = true;
        userRes.errorMessage = action.data.message;
        return userRes;
      }
      userRes.error = false;
      userRes.message = action.data.message;
      return userRes;
    }

    case SUBMIT_LAUNCH_CARRIER_FAILED: {
      return Object.assign({}, state, action.error);
    }
    case SUBMIT_LAUNCH_CARRIER_RESET:
      return initialState;

    default:
      return state;
  }
}
